<app-install-new-bin isSwap="{{ true }}"></app-install-new-bin>
